module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 1627
// module chunks = 1